import React from "react";
import clsx from "clsx";
import { Button, ButtonProps } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import FiltersArrowsSort from "../coach-clients/FiltersArrowsSort";
import { ProgramTemplateSort } from "@growth-machine-llc/stridist-api-client";

interface ProgramNameSortButtonProps extends ButtonProps {
  sort: ProgramTemplateSort;
  onChangeSort?: (sort: ProgramTemplateSort) => void;
}

const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: "bold",
    fontSize: 15,
    textTransform: "none",
    padding: 0,
    minWidth: "auto",
    "&:hover": { backgroundColor: "transparent" },
  },
  active: {
    color: theme.palette.primary.main,
  },
  inactive: {
    color: theme.palette.text.primary,
  },
}));

export const ProgramNameSortButton = ({
  sort,
  onChangeSort,
  className,
  ...other
}: ProgramNameSortButtonProps) => {
  const s = useStyles();

  const isActiveAsc = sort === ProgramTemplateSort.NAME_ASC;
  const isActiveDesc = sort === ProgramTemplateSort.NAME_DESC;
  const isActive = isActiveAsc || isActiveDesc;

  const handleClick = () => {
    let nextSort: ProgramTemplateSort;

    if (!isActiveAsc && !isActiveDesc) {
      nextSort = ProgramTemplateSort.NAME_ASC;
    } else if (isActiveAsc) {
      nextSort = ProgramTemplateSort.NAME_DESC;
    } else {
      nextSort = null;
    }

    onChangeSort?.(nextSort);
  };

  return (
    <Button
      {...other}
      className={clsx(s.root, className, {
        [s.active]: isActive,
        [s.inactive]: !isActive,
      })}
      endIcon={
        <FiltersArrowsSort activeUp={isActiveAsc} activeDown={isActiveDesc} />
      }
      onClick={handleClick}
      disableRipple
    >
      Name
    </Button>
  );
};
